import type {
  HandleResolutionSetupChange,
  ResolutionSetup
} from '@library/types/resolutions/resolutionDetails';
import { Combobox } from '@library/components/selects';
import { ResolutionDetailsStep } from '@bo-components/resolutions/resolutionDetails';
import { useResolutionDetailsSetup } from '@bo-hooks/resolutions/resolutionDetails';

export interface ResolutionDetailsSetupProps {
  onChangeResolutionSetup: HandleResolutionSetupChange;
  onClickContinue: () => void;
  resolutionSetup: ResolutionSetup;
}

export const CreateResolutionSetup = ({
  onChangeResolutionSetup,
  onClickContinue,
  resolutionSetup
}: ResolutionDetailsSetupProps) => {
  const { resolutionInputType, resolutionType } = resolutionSetup;
  const isDisabled = !resolutionInputType || !resolutionType;

  const {
    onChangeResolutionInputType,
    onChangeResolutionType,
    resolutionTypeOptions,
    resolutionInputTypeOptions,
    selectedResolutionInputTypeOption,
    selectedResolutionTypeOption
  } = useResolutionDetailsSetup({
    resolutionSetup,
    onChangeResolutionSetup
  });

  return (
    <ResolutionDetailsStep
      isDisabled={isDisabled}
      onClickContinue={onClickContinue}
    >
      <div className="w-96 shrink-0" data-testid="resolution-type-selection">
        <p className="text-soClean-180 w-full rounded-md pb-2 text-sm leading-6">
          Resolution Type
        </p>
        <div className="border-0">
          <Combobox
            closeMenuOnSelect
            id="resolutionType"
            isClearable={false}
            isMulti={false}
            onChange={onChangeResolutionType}
            options={resolutionTypeOptions}
            value={selectedResolutionTypeOption || null}
            valueClassName="py-[11px]"
          />
        </div>
      </div>
      <div
        className="w-96 shrink-0"
        data-testid="resolution-input-type-selection"
      >
        <p className="text-soClean-180 w-full rounded-md pb-2 text-sm leading-6">
          Resolution Input Type
        </p>
        <div className="border-0">
          <Combobox
            closeMenuOnSelect
            id="resolutionInputType"
            isClearable={false}
            isMulti={false}
            onChange={onChangeResolutionInputType}
            options={resolutionInputTypeOptions}
            value={selectedResolutionInputTypeOption || null}
            valueClassName="py-[11px]"
          />
        </div>
      </div>
    </ResolutionDetailsStep>
  );
};
